import { inject, injectable } from 'inversify';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import Request from '@framework/api/Rpc/Request';
import { type IDispatcher } from '@dm-portal/json-rpc-dispatcher';
import DITypes from '@dm-portal/json-rpc-dispatcher/DITypes';
import withCache from '@framework/with-cache';

@injectable()
class CountryRepository {
  constructor(@inject(DITypes.JsonRpcDispatcher) private readonly rpc: IDispatcher) {}

  @withCache
  async getCountries(): Promise<any> {
    const request = new Request('dm_portal.queries.get_country_list');
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  }
}

export default CountryRepository;
